import { useNavigate } from "react-router-dom";
import { Drawer, Box, MenuItem, Typography, Button } from "@mui/material";
import ToggleColorMode from "../homePage/ToggleColorMode";
import SearchBar from "./SearchBar";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../store/userSlice";
const MobileMenu = ({
  open,
  setOpen,
  toggleDrawer,
  options,
  searchValue,
  handleChange,
  handleSearch,
  handleSignUp,
  showPricing=false,
  showTermsAndCondition=false,
  showPrivacy = false,
  showContactUs = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const handleLogout = () => {
    setOpen(false);
    dispatch(setUser(null));
  };
  return (
    <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
      <Box
        sx={{
          minWidth: "50dvw",
          p: 2,
          backgroundColor: "background.paper",
          flexGrow: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            flexGrow: 1,
          }}
        >
          <ToggleColorMode />
        </Box>
        <Box sx={{ py: 2 }}>
          <SearchBar
            options={options}
            searchValue={searchValue}
            handleSearch={handleSearch}
            handleChange={handleChange}
          />
        </Box>
        <Box sx={{ px: 2 }}>
        <MenuItem
            onClick={() => window.location.href = "https://www.nexensus.com/aboutcompany"}
            sx={{ py: "6px", px: "12px" }}
          >
            <Typography variant="body2" color="text.primary">
              About Us
            </Typography>
          </MenuItem>
          
          <MenuItem
            onClick={() => navigate("/pricing")}
            sx={{ py: "6px", px: "12px" }}
          >
            <Typography variant="body2" color="text.primary">
              Pricing
            </Typography>
          </MenuItem>
          
            <MenuItem
        onClick={() => navigate("/Contact-us")}
        sx={{ py: "6px", px: "12px" }}
      >
        <Typography variant="body2" color="text.primary">
          Contact Us
        </Typography>
      </MenuItem>
    
            <MenuItem
            onClick={() => navigate("/Privacy")}
            sx={{ py: "6px", px: "12px" }}
          >
            <Typography variant="body2" color="text.primary">
              Privacy
            </Typography>
          </MenuItem>
         
            <MenuItem
            onClick={() => navigate("/terms-of-service")}
            sx={{ py: "6px", px: "12px" }}
          >
            <Typography variant="body2" color="text.primary">
              Term of Service
            </Typography>
          </MenuItem>
         
          {user && (
            <>
              <MenuItem
                onClick={() => navigate("/coming-soon")}
                sx={{ py: "6px", px: "12px" }}
              >
                <Typography variant="body2" color="text.primary">
                  Profile
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/coming-soon")}
                sx={{ py: "6px", px: "12px" }}
              >
                <Typography variant="body2" color="text.primary">
                  My Orders
                </Typography>
              </MenuItem>
            </>
          )}
        </Box>
        {user ? (
          <Box
            sx={{
              position: "absolute",
              bottom: "5%",
              width: "90%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Button
              fullWidth
              color="primary"
              variant="contained"
              size="medium"
              onClick={handleLogout}
            >
              Sign Out
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              position: "absolute",
              bottom: "5%",
              width: "90%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Button
              fullWidth
              color="primary"
              variant="contained"
              size="medium"
              onClick={handleSignUp}
            >
              Sign in
            </Button>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              size="medium"
              onClick={handleSignUp}
            >
              Sign up
            </Button>
          </Box>
        )}
      </Box>
    </Drawer>
  );
};
export default MobileMenu;